<div class="webinar-landing-page">
    <div class="container minimum-height" id="skrollr-body">
        <div class="webinar-sign-up">
            <div class="webinar-sign-up__title">
                <p class="webinar-sign-up__eyebrow c11n-text-sm">
                    {{ 'webinar.header' | translate }}
                </p>
                <h1>{{ 'webinar.title' | translate }}</h1>
                <p class="c11n-text-md">
                    {{ 'webinar.description' | translate }}
                </p>
            </div>
            <div *ngIf="filteredSessions.length > 0; else noSessions" class="webinar-links">         
                <table class="c11n-table c11n-table--medium " aria-label="Webinar links with intended audiences, dates, and times listed">
                    <thead>
                      <tr class="c11n-table__tr">
                        <th id="date-header" scope="col" class="c11n-table__thead-th c11n-table__thead-th--align-left">{{ 'webinar.date_time' | translate }}</th>
                        <th id="program-header" scope="col" class="c11n-table__thead-th c11n-table__thead-th--align-left">{{ 'webinar.program' | translate }}</th>
                        <th id="link-header" scope="col" class="c11n-table__thead-th c11n-table__thead-th--align-left">{{ 'webinar.link' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let session of filteredSessions" class="c11n-table__tr">
                            <td class="c11n-table__td c11n-table__td--align-left">
                                {{ session.date | dateFormat:'dddd, M/D h:mma' }}
                            </td>
                            <td class="c11n-table__td c11n-table__td--align-left">
                                {{ session.program }}
                            </td>
                            <td class="c11n-table__td c11n-table__td--align-left">
                                <a class="c11n-link c11n-link--icon c11n-link--trailing-icon c11n-link--primary " [href]="session.link"
                                target="_blank">
                                    <span class="c11n-link__content">
                                        <span class="c11n-link__text">{{ 'webinar.sign_up' | translate }}</span>
                                        <svg class="c11n-pop-window-small">
                                            <use xlink:href="#pop-window-small"></use>
                                        </svg>
                                    </span>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <ng-template #noSessions>
                <div class="webinar-sign-up__no-sessions">
                    <p class="c11n-text-md">
                        {{ 'webinar.no_sessions' | translate }}
                    </p>
                </div>
            </ng-template>
        </div>
    </div>
</div>
